import React from "react";
import css from "./style.scss";
import greentick from "../../../assets/images/greentick.svg";
import ProgressBar from "../../Campaigns/Dashboard/ProgressBar";
import classNames from "classnames";
import { MAX_DAILY_CALLS } from "../../../data/user/constants";

const CallProgress = ({
    callCountForToday = 0,
    maxCalls = MAX_DAILY_CALLS,
}) => {
    const progress = Math.min((callCountForToday / maxCalls) * 100, 100);
    const isCompleted = callCountForToday >= maxCalls;
    return (
        <div className={css.tcpCard}>

            <div className={css.callModeWrapper}>
                <p className={css.callModeHeader}>Daily Call Progress</p>
                <div className={css.callModeRow}>
                    <div className={css.callMode}>
                        Calls Made:
                        <span className={classNames(css.callModeVal, { [css.maxReached]: callCountForToday >= maxCalls })}>
                            &nbsp;{callCountForToday}/{maxCalls}
                        </span>
                    </div>

                    {isCompleted && (
                        <img src={greentick} alt="Green Tick" />
                    )}
                </div>
            </div>

            <ProgressBar value={progress} showHeader={false} isSmallSize={true} />

            <span className={css.tcpNote}>
                Outbound calling includes up to <span className={css.callLimit}>{MAX_DAILY_CALLS}</span> <br /> <span className={css.callLimit}>calls</span> per day to support connection <br /> quality and number reputation.
            </span>

        </div>

    );
};

export default CallProgress;